module.exports = __webpack_public_path__ + "media/images/icons/filled/zhihu-circle-53baec1ff11c2382f5c6447f1cf674c7.svg";